import { useMemo } from 'react';
import { useTranslation } from '@blocs.i18n';
import { useArtistContext } from '../core/ArtistContext';

/**
 * "You're All Set" info modal shown instead of the scheduling page while the
 * talent has an upcoming headshot session, on any plan term. The session time
 * renders in the studio's timezone. `useHeadshotModal` owns which modal is open.
 */
export const useHeadshotBookedModal = () => {
  const { headshotEligibility } = useArtistContext();
  const { formatIntlDateAtTime } = useTranslation();
  const upcomingSession = headshotEligibility?.upcomingSession;

  const sessionDateTime = upcomingSession
    ? formatIntlDateAtTime({
        date: upcomingSession.appointmentAt,
        dateFormat: 'WEEKDAY_MONTH_LONG_DAY',
        timeFormat: 'TIME',
        timeZoneStandardName: upcomingSession.appointmentTimezone,
        replaceUtc: false,
      })
    : '';

  return useMemo(() => ({ sessionDateTime }), [sessionDateTime]);
};

export type UseHeadshotBookedModalValues = ReturnType<typeof useHeadshotBookedModal>;
